import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import CphereHeaderLogo from "./CphereHeaderLogo";

export default function CortexDashboardBrandLink({
  className = "",
  linkTestId,
  logoClassName = "",
  logoTestId = "cphere-page-brand-logo",
}) {
  const navigate = useNavigate();

  const returnToDashboard = useCallback(
    (event) => {
      event.preventDefault();
      navigate("/dashboard");
    },
    [navigate]
  );

  return (
    <a
      aria-label="Return to Cortex dashboard"
      className={`cphere-cortex-dashboard-brand-link ${className}`.trim()}
      data-testid={linkTestId}
      href="/dashboard"
      onClick={returnToDashboard}
    >
      <CphereHeaderLogo
        alt="Cphere brain brand"
        className={logoClassName}
        data-testid={logoTestId}
        draggable={false}
      />
    </a>
  );
}
